import _ from 'lodash';
import { useEffect } from 'react';
export var setCustomerFromQueryParams = function(param) {
    var Cart = param.Cart, queryParams = param.queryParams, isUserLoggedIn = param.isUserLoggedIn;
    var params = {};
    _.forEach(_.keys(queryParams), function(key) {
        if (_.startsWith(key, 'dtche')) {
            var _key_match;
            var dtcheKey = (_key_match = key.match(/\[(.*?)\]/)) === null || _key_match === void 0 ? void 0 : _key_match[1];
            if (dtcheKey) {
                params[dtcheKey] = queryParams[key];
            }
        } else {
            params[key] = queryParams[key];
        }
    });
    var birthdate = params.birthdate, email = params.email, firstName = params.firstName, lastName = params.lastName, medCardExpiration = params.medCardExpiration, medCardNumber = params.medCardNumber, medCardState = params.medCardState, phone = params.phone, stateResidency = params.stateResidency;
    var guestCustomerObj = _.omitBy({
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        email: email,
        birthMonth: _.slice(birthdate, 0, 2).join(''),
        birthDay: _.slice(birthdate, 2, 4).join(''),
        birthYear: _.slice(birthdate, 4, 8).join(''),
        stateResidency: stateResidency
    }, _.isEmpty);
    if (!isUserLoggedIn) {
        _.mapKeys(guestCustomerObj, function(value, key) {
            return Cart.updateGuestCustomer(key, value);
        });
    }
    if (medCardNumber) {
        Cart.setMedicalCardNumber(medCardNumber);
    }
    if (medCardExpiration) {
        Cart.setMedicalCardExpiration(medCardExpiration);
    }
    if (medCardState) {
        Cart.setMedicalCardState(medCardState);
    }
};
export var useCustomerFromQueryParams = function(param) {
    var Cart = param.Cart, queryParams = param.queryParams, isUserLoggedIn = param.isUserLoggedIn;
    useEffect(function() {
        setCustomerFromQueryParams({
            Cart: Cart,
            queryParams: queryParams,
            isUserLoggedIn: isUserLoggedIn
        });
    }, [
        Cart,
        queryParams
    ]);
};
